var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgEdit = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M15.188 7.871v7.317H2.813V2.813h7.312" }), _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "m6.75 11.25.439-2.561L13.376 2.5a1.524 1.524 0 0 1 2.123 0 1.5 1.5 0 0 1 0 2.122l-6.189 6.19z" })] }))); };
export default SvgEdit;
